const PERSONAL_INFO: string = '/personal-info';
const EDIT_PERSONAL_INFO: string = '/edit-personal-info';
const KALP_PRODUCTS: string = '/applications';
const SUBSCRIPTION: string = '/subscription';
const CREDIT: string = '/credit';
const TRANSACTION: string = '/transactions';
const KYC_VERIFICATION: string = '/kyc-verification';
const SETTINGS: string = '/settings';
const PASSWORD_UPDATE: string = '/password-update';
const ROOT: string = '/';
const LOGIN: string = '/login';
const SIGN_UP: string = '/sign-up';
const SIGN_UP_NEW: string = '/social-signup';
const SIGN_UP_IBW ='/ibw-signup'

const VERIFY_CREATE_EMAIL: string = '/verify-email';
const CHANGE_PASSWORD: string = '/change-password';
const TWOFA: string = '/2fa';
const TERMS_AND_CONDITIONS: string = '/terms';
const PRIVACY_POLICY: string = '/privacy';

const PAGE_NOT_FOUND: string = '*';
const REDIRECTION="/redirection"


const path = {
  PERSONAL_INFO,
  EDIT_PERSONAL_INFO,
  KALP_PRODUCTS,
  SUBSCRIPTION,
  CREDIT,
  TRANSACTION,
  SETTINGS,
  PASSWORD_UPDATE,
  ROOT,
  LOGIN,
  SIGN_UP,
  CHANGE_PASSWORD,
  PAGE_NOT_FOUND,
  KYC_VERIFICATION,
  VERIFY_CREATE_EMAIL,
  TWOFA,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
  REDIRECTION,
  SIGN_UP_NEW,
  SIGN_UP_IBW
};

export default path;
